//jshint esversion:6
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import AuthGuard from '@/AuthGuard';

// import Login from '@/views/auth/Login.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/venta',
    name: 'crear-venta',
    component: ()=> import(/*webpackChunkName: "CreateBill"*/'../views/CreateBill.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/servicios-pendientes',
    name: 'pendientes',
    component: ()=> import('@/views/Pendientes.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/inventario',
    name: 'inventario',
    component: ()=> import('@/views/Inventario.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/entregados',
    name: 'entregados',
    component: ()=> import('@/views/Entregados.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/caja',
    name: 'caja',
    component: ()=> import('@/views/Caja.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/ventas',
    name: 'ventas',
    component: ()=> import('../views/Ventas.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: ()=> import('../views/Clientes.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: ()=> import('../views/Usuarios.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/servicios',
    name: 'servicios',
    component: ()=> import('@/views/Servicios.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/productos',
    name: 'productos',
    component: ()=> import('@/views/Productos.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/categorias',
    name: 'categorias',
    component: ()=> import('@/views/Categorias.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/promos',
    name: 'promos',
    component: ()=> import('@/views/Promos.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/reportes',
    name: 'reportes',
    component: ()=> import('@/views/Reportes.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/reportes/inventarios',
    name: 'inventarios-realizados',
    component: ()=> import('../components/Reports/ReporteInventarios.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/reportes/movimientos-caja',
    name: 'movimientos-caja',
    component: ()=> import('../components/Reports/ReporteMovimientosCaja.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/config',
    name: 'config',
    component: ()=> import('@/views/Config.vue'),
    beforeEnter: AuthGuard
  },
  {
    path: '/login',
    name: 'login',
    component: ()=> import('@/views/auth/Login.vue')
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router;
